export default "__VITE_ASSET__DtKFf1d4__"